const get = (state) => state.authenticationInfo;
export const getTokens = state => get(state).tokens;